import Loadable from 'react-loadable';
import Loading from 'skd-ui/Loading/Loading';

export default Loadable({
	loader: () => import(/* webpackChunkName: 'Order'*/ 'src/controllers/Order/Order'),
	loading: Loading,
});
